<template>
  <div class="footerMain">
    <!-- H5 -->
    <div v-if="getIsMobile">
      <div v-for="(fModeObj, index) in footerData" :key="index">
        <FooterMoudle :fModeObj="fModeObj" :rowIndex="index" />
      </div>
      <div class="h5-image" v-if="imageRight">
        <img class="h5-image-img" :src="$utils.returnImgUrl(imageRight)" alt="" />
      </div>
    </div>
    <div v-else>
      <!-- 行 数组-->
      <div class="lineArr" v-for="(fLine, index) in footerDataPc" :key="index">
        <!-- 列 数组-->
        <div class="columnArr" v-for="(fcolumn, i) in fLine" :key="i">
          <div v-for="(fModeObj, j) in fcolumn" :key="j">
            <FooterMoudle :fModeObj="fModeObj" :rowIndex="index" />
          </div>
        </div>
      </div>
      <div class="footer-image footer-image-left" v-if="imageLeft">
        <img class="footer-image-left-img" :src="$utils.returnImgUrl(imageLeft)" alt="" />
      </div>
      <div class="footer-image footer-image-right" v-if="imageRight">
        <img class="footer-image-right-img" :src="$utils.returnImgUrl(imageRight)" alt="" />
      </div>
      <div
        class="footer-image footer-image-center"
        v-if="imageCenter"
        :style="{ backgroundImage: `url(${$utils.returnImgUrl(imageCenter)})` }"
      ></div>
    </div>
    <div class="banquanTxt">{{ banquanTxt() }}</div>
  </div>
</template>

<script>
import { getBottomTemplate } from "@/lobby_common/api/basic_gen";
import FooterMoudle from "./moudle/footerMoudle.vue";
import { mapGetters } from "vuex";
import { changeFooterData, isTg } from "@/lobby_common/utils/utils.js";
export default {
  name: "Footer",
  components: {
    FooterMoudle,
  },
  data() {
    return {
      footerData: [], // 底部数据
      footerDataPc: [], // 底部数据PC
      footerImage: null, // 底部图片
    };
  },
  async created() {
    this.getBottomListFun();
  },
  mounted() {},
  computed: {
    ...mapGetters(["brandDetail", "getIsMobile"]),
    iconList: function () {
      if (!this.brandDetail.socialPlatform) return [];
      return this.brandDetail.socialPlatform || [];
    },
    imageLeft: function () {
      if (this.footerImage?.languages?.length) {
        return this.footerImage.languages[0]?.leftImage || "";
      }
      return "";
    },
    imageRight: function () {
      if (this.footerImage?.languages?.length) {
        return this.footerImage.languages[0]?.rightImage || "";
      }
      return "";
    },
    imageCenter: function () {
      if (this.footerImage?.languages?.length) {
        return this.footerImage.languages[0]?.image || "";
      }
      return "";
    },
  },
  methods: {
    // 获取底部模板
    async getBottomListFun() {
      const res = await getBottomTemplate({
        useTerminals: this.getIsMobile ? "H5" : "PC",
      });
      const { code, data } = { code: -1, data: {}, ...res };
      if (code === 0) {
        this.footerData = data.cols || [];
        this.footerDataPc = changeFooterData(this.footerData);
        this.footerImage = (data.cols || []).find(
          (item) => item.showType === "TEMPLATE_BOTTOM_COL_SHOW_TYPE_DISPLAY_BACKGROUND"
        );
      }
    },
    banquanTxt() {
      const date = new Date();
      const year = date.getFullYear();
      const domain = isTg() ? "" : window.location.hostname;
      const version = window.BASEAPI.VUE_APP_VERSION;
      return `Copyright ©${year} ${domain} All rights reserved. Version ${version}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.footerMain {
  margin: 0 auto;
  padding: 20px 0px 30px;
  box-sizing: border-box;
  overflow: hidden;
  max-width: 1270px;
  margin: 0 auto;
  // background: var(--background-300);
  color: var(--font-color-900);
  @media (max-width: 768px) {
    width: 100%;
    padding: 20px 15px 100px !important;
  }
}
@media screen and (max-width: 768px) {
  .footerMain {
    padding-top: 25px !important;
    padding-bottom: 70px;
    background: none;
  }
}
.lineArr {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
  .columnArr {
    flex: 1;
    width: 100px;
    margin: 0 10px;
  }
}
.banquanTxt {
  font-size: 12px;
  text-align: center;
  color: var(--font-color-900);
}
.footer-image {
  position: absolute;
  top: 0;
  height: 99%;
  &.footer-image-left {
    left: 10px;
    z-index: -100;
  }
  &.footer-image-right {
    right: 10px;
    z-index: -100;
  }
  &.footer-image-center {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    z-index: -100;
  }
  .footer-image-left-img,
  .footer-image-right-img {
    width: auto;
    height: 100%;
  }
}
.h5-image {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50%;
  &-img {
    width: 100%;
    margin-bottom: 55px;
  }
}
</style>
